import {
  Box,
  Button,
  Card,
  Chip,
  IconButton,
  Typography,
  Paper,
} from "@mui/material";
import { useRef } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const OngoingWork = () => {
  const navigate = useNavigate();
  const ongoingWork = [
    {
      id: 1,
      title: "Billboard Installation",
      startDate: "10 Aug 2024",
      endDate: "25 Sep 2024",
      status: "12 Units",
    },
    {
      id: 2,
      title: "In-Store Branding",
      startDate: "01 Oct 2024",
      endDate: "15 Dec 2024",
      status: "18 Locations",
    },
    {
      id: 3,
      title: "LED Signage Setup",
      startDate: "05 Jul 2024",
      endDate: "20 Aug 2024",
      status: "30 Panels",
    },
    {
      id: 4,
      title: "Hoarding Replacement",
      startDate: "15 Sep 2024",
      endDate: "10 Nov 2024",
      status: "9 Sites",
    },
    {
      id: 5,
      title: "Digital Display Installation",
      startDate: "22 Jun 2024",
      endDate: "05 Aug 2024",
      status: "25 Screens",
    },
    {
      id: 6,
      title: "Mall Branding Campaign",
      startDate: "01 Oct 2024",
      endDate: "30 Oct 2024",
      status: "6 Malls",
    },
    {
      id: 7,
      title: "Airport Ad Panels",
      startDate: "12 Sep 2024",
      endDate: "28 Oct 2024",
      status: "15 Panels",
    },
  ];

  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      scrollRef.current.scrollTo({
        left:
          direction === "left"
            ? scrollLeft - clientWidth
            : scrollLeft + clientWidth,
        behavior: "smooth",
      });
    }
  };

  return (
    <Card
      elevation={1}
      sx={{
        borderRadius: 5,
        boxShadow: 6,
        p: 2,
        width: "100%", // takes full width of parent
        minHeight: "100%",
        margin: "auto",
      }}
    >
      <Box
        mx={2}
        py={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1} // same spacing as CardHeader usually provides
        borderBottom={1}
        borderColor="divider"
      >
        <Typography variant="h6" fontWeight={600}>
          Ongoing Work
        </Typography>

        <Box sx={{ display: "flex", gap: 1 }}>
          <IconButton
            size="small"
            onClick={() => scroll("left")}
            sx={{
              p: 0.5, // smaller padding
              border: 1, // thin border
              borderColor: "grey.400",
              width: 30,
              height: 30,
            }}
          >
            <ArrowBackIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={() => scroll("right")}
            sx={{
              p: 0.5, // smaller padding
              border: 1, // thin border
              borderColor: "grey.400",
              width: 30,
              height: 30,
            }}
          >
            <ArrowForwardIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>

      <Box>
        <Box
          ref={scrollRef}
          sx={{
            display: "flex",
            overflowX: "auto",
            width: "100%",
            gap: 2,
            scrollBehavior: "smooth",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          {ongoingWork.map((work) => (
            <div
              key={work.id}
              className="max-w-[260px] bg-indigo-600 text-white p-4 rounded-xl flex-shrink-0"
            >
              <span className="text-xs font-semibold bg-indigo-100 text-indigo-700 px-2 py-1 rounded-md mb-2 inline-block">
                Fabrication
              </span>
              <h3 className="font-bold text-base mb-2">{work.title}</h3>
              <div className="flex items-center text-sm border-b border-white/30 pb-2 mb-2">
                {/* <FaCalendarAlt className="text-xs mr-2" /> */}
                <span>
                  {work.startDate} - {work.endDate}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm">{work.status}</span>
                <button
                  onClick={() => navigate("/vendorportal/jobs/cluster")}
                  className="bg-blue-500 hover:bg-blue-600 text-white text-sm px-3 py-1 rounded-md"
                >
                  View
                </button>
              </div>
            </div>
          ))}
        </Box>
      </Box>
    </Card>
  );
};

export default OngoingWork;
